const moment = require("moment");
const { HeaderPositionType } = require("../../constants");

const devTemplates = [];

// devTemplates.push({
//     getInstanceProps: () => ({
//         elementType: "Map",
//
//     }), getStaticProps: () => ({
//         id: "map_world",
//         icon: "map_world",
//         title: "World Map",
//         description: "",
//         category: "people",
//         tags: "",
//         isComingSoon: true
//     })
// });

devTemplates.push({
    getInstanceProps: () => ({
        elementType: "DebugBox"
    }), getStaticProps: () => ({
        id: "debug_box",
        icon: "debug_box",
        title: "Debug Box",
        category: "organization",
        tags: "",
    })
});

// devTemplates.push({
//     getInstanceProps: () => ({
//         elementType: "Embed",
//
//         defaultData: {
//             layout: {
//                 headerPosition: HeaderPositionType.NONE,
//                 showFooter: "off",
//             }
//         },
//
//         allowHeader: true,
//         allowFooter: true,
//
//         allowColorful: false,
//     }), getStaticProps: () => ({
//         id: "embed",
//         icon: "debug_box",
//         title: "Fullscreen Embed",
//         category: "impact",
//         tags: "embed iframe external"
//     })
// });
//
// devTemplates.push({
//     getInstanceProps: () => ({
//         elementType: "Embed"
//     }), getStaticProps: () => ({
//         id: "embed_title",
//         icon: "debug_box",
//         title: "Embed with Title",
//         category: "impact",
//         tags: "embed iframe external",
//     })
// });

module.exports = devTemplates;
